import { theme } from "@hiver/hiver-ui-kit";

export const AI_QUERIES = {
  AI_TAGS_DATA: "ai_tags_data",
};

export const EDIT_TAG_DIALOG_STATE = {
  UPDATE: "UPDATE",
  REMOVE_DESCRIPTION: "REMOVE_DESCRIPTION",
};

export const REMOVE_FILTER_TEXT = "Remove filter";
export const DESCRIPTION_FILTER_TYPE = {
  EMPTY: "empty_description",
  NOT_EMPTY: "non_empty_description",
};

export const TAGS_AVAILABILITY_FILTER_TYPE = {
  INCLUDE: "included_tags",
  EXCLUDE: "excluded_tags",
  DECIDED_BY_HIVER: "decided_by_hiver",
};

export const TAGS_AVAILABILITY_FILTER_TYPE_VALUES = {
  [TAGS_AVAILABILITY_FILTER_TYPE.INCLUDE]: 1,
  [TAGS_AVAILABILITY_FILTER_TYPE.EXCLUDE]: 0,
  [TAGS_AVAILABILITY_FILTER_TYPE.DECIDED_BY_HIVER]: -1,
};

export const descriptionFilters = [
  {
    type: DESCRIPTION_FILTER_TYPE.NOT_EMPTY,
    text: "Tags with description",
  },
  {
    type: DESCRIPTION_FILTER_TYPE.EMPTY,
    text: "Tags without description",
  },
  {
    type: "",
    text: REMOVE_FILTER_TEXT,
    color: theme.palette.purple.primary,
  },
];

export const availabilityFilters = [
  {
    type: TAGS_AVAILABILITY_FILTER_TYPE.DECIDED_BY_HIVER,
    text: "Decided by Hiver",
  },
  {
    type: TAGS_AVAILABILITY_FILTER_TYPE.INCLUDE,
    text: "Always included",
  },
  {
    type: TAGS_AVAILABILITY_FILTER_TYPE.EXCLUDE,
    text: "Always excluded",
  },
  {
    type: "",
    text: REMOVE_FILTER_TEXT,
    color: theme.palette.purple.primary,
  },
];

export const TAGS_DESCRIPTION_GS_EVENTS = {
  ADD_CLICKED: "AP_tag_description_add_clicked",
  SAVED: "AP_tag_description_saved",
  SAVE_CANCELLED: "AP_tag_description_cancelled",
  SORTED: "AP_tag_filter_applied",
  SEARCH: "AP_tag_description_search",
  EDIT_CLICKED: "AP_tag_description_edit_clicked",
  REMOVE_CLICKED: "AP_tag_description_remove_clicked",
};
